module.exports = __webpack_public_path__ + "img/heroFormActive.01c55629.svg";